export const Role = {
    admin: { requiresAuth: true, adminAuth: true, buyerAuth: false, supplierAuth: false },
    supplier: { requiresAuth: true, adminAuth: false, buyerAuth: false, supplierAuth: true },
    buyer: { requiresAuth: true, adminAuth: false, buyerAuth: true, supplierAuth: false },
    user: { requiresAuth: false, adminAuth: false, buyerAuth: false, supplierAuth: false }
}